﻿import { useEffect, useRef } from 'react';

import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { SKUProfile } from 'pages/sku_management/components/SKUProfile';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import GMetrixBanner from 'components/GMetrixBanner/GMetrixBanner';
import { useSKUDetails } from 'pages/sku_management/context';
import { useNotification } from 'app/notifications';
import { PageWithHeader } from 'components/layout';
import { KendoIntlProvider } from 'app/culture';
import { useSuperState } from 'hooks';
import { SKUApi } from 'apis/SKUApi';
import { useIntl } from 'react-intl';

export const SKUDetail = () => {

    const { formatMessage, locale } = useIntl();
    const { id } = useParams();
    const skuId = Number(id);
    const navigate = useNavigate();
    const location = useLocation();
    const { catchWithToast, createToast } = useNotification();
    const { open, pageContext, setSubTabIndex } = useSKUDetails();
    const gmetrixBannerRef = useRef<any>();

    const [state, setState] = useSuperState({
        loading: true
    });

    const { loading } = state;

    const loadSKU = async () => {

        try {

            setState({ loading: true });
            setSubTabIndex([]);

            const skuName = (location.state as { title?: string } | null)?.title ?? '';

            const sku = await SKUApi.Get(skuName, skuId).catch(error => {

                catchWithToast(formatMessage({ id: 'failed_to_load_sku_details_please_try_ag.27db7c16', defaultMessage: 'Failed to load SKU details. Please try again.' }))(error);
                return undefined;

            });

            if (!sku) {

                createToast(formatMessage({ id: 'failed_to_load_sku_details_please_try_ag.27db7c16', defaultMessage: 'Failed to load SKU details. Please try again.' }), 'danger');

                navigate('/sku-management');
                return;

            }

            open({
                Data: {
                    skuDetails: sku,
                    skuDetailsOriginal: sku
                },
                HasChanges: false,
                Id: Number(sku.Id),
                Title: sku.Name
            });

            setState({ loading: false });

        } catch (e) {

            console.error(e);
            createToast(formatMessage({ id: 'failed_to_load_sku_details_please_try_ag.27db7c16', defaultMessage: 'Failed to load SKU details. Please try again.' }), 'danger');
            navigate('/sku-management');

        }

    };

    useEffect(() => {

        loadSKU();

    }, [skuId]);

    return (
        <KendoIntlProvider >
            <LocalizationProvider language={locale}>
                <IntlProvider locale={locale}>
                    <div className={'sku-detail'}>

                        <GMetrixBanner ref={gmetrixBannerRef} />

                        <PageWithHeader
                            headerConfig={{
                                title: pageContext?.Id === skuId
                                    ? (pageContext?.Title ?? '')
                                    : ((location.state as { title?: string } | null)?.title ?? ''),
                                trail: [{ label: formatMessage({ id: 'sku_management.6a91ee80', defaultMessage: 'SKU Management' }), to: '/sku-management' }]
                            }}
                        >
                            {loading || !pageContext ?
                                (
                                    <div className={'d-flex align-items-center justify-content-center'} style={{ height: 300 }}>
                                        <GMetrixLoader />
                                    </div>
                                )
                                :
                                (
                                    <SKUProfile />
                                )
                            }
                        </PageWithHeader>
                    </div>
                </IntlProvider>
            </LocalizationProvider>
        </KendoIntlProvider>
    );

};
